const TarotCards = () => import(/* webpackChunkName 'TarotCards' */ '@/components/Astrology/Tarot/TarotCard/TarotCardsList/TarotCardsList.vue');
const TarotFortunes = () => import(/* webpackChunkName 'TarotFortunes' */ '@/components/Astrology/Tarot/TarotFortune/TarotFortunesList/TarotFortunesList.vue');
const TarotResults = () => import(/* webpackChunkName 'TarotResults' */ '@/components/Astrology/Tarot/TarotResult/TarotResultsList/TarotResultsList.vue');

export default {
    path: 'tarot',
    name: 'tarot',
    redirect: 'tarot-cards/',
    meta: {
        label: 'Tarot'
    },
    component: {
        name: 'Tarot',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: 'tarot-cards',
            name: 'tarot-cards',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Cards'
            },
            component: TarotCards
        },
        {
            path: 'tarot-fortunes',
            name: 'tarot-fortunes',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Fortunes'
            },
            component: TarotFortunes
        },
        {
            path: 'tarot-results',
            name: 'tarot-results',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Results'
            },
            component: TarotResults
        }
    ]
};